import { docReady, qsa, initResizeEvents } from "@libs/helpers";
import { media } from "@parts/media";

const toggleAttr = ( el, attr ) => {
    const state = el.getAttribute( attr );
    const newState = state === "true" ? "false" : "true";
    el.setAttribute( attr, newState );
    return newState;
};

docReady(() => {

    const closeAll = () => {
		qsa('.menu-list', (menu) => {
			menu.setAttribute('data-state', 'closed');
			menu.setAttribute('aria-expanded', 'false');
		});
    };

    qsa('.sidebar-menu', (el) => {

        const btn = el.querySelector('.menu-button');
        const list = el.querySelector('.menu-list');

        if (!btn || !list) {
            return;
        }

        const openMenu = () => {
            closeAll();
            list.setAttribute('data-state', 'open');
            list.setAttribute('aria-expanded', 'true');
        };

        btn.addEventListener('click', e => {

            const btnState = toggleAttr(btn, 'aria-pressed');
            const state = list.getAttribute('data-state');
            const expanded = list.getAttribute('aria-expanded');

            closeAll();

            if (state === 'open' || expanded === 'true') {
                list.setAttribute('data-state', 'closed');
                list.setAttribute('aria-expended', 'false');
            } else {
                list.setAttribute('data-state', 'open');
                list.setAttribute('aria-expanded', 'true');
            }

            e.preventDefault;
        });

    });
});
